export default __webpack_public_path__ + "static/media/fbdd3b90609d9e0dfa4624c6e3835cb3.23d4290f.png";